import React from 'react';

import { getComponentClasses } from '../../utils/app';
import { Avatar } from '../Avatar';
import { DisplayName } from '../DisplayName';

export interface Props {
    user: {
        name: string;
        profileUrl: string;
        avatarUrl: string;
        isActive?: boolean;
    };
    variations?: string[];
    displayNameVariations?: string[];
    avatarVariations?: string[];
    isTruncated?: boolean;
    isLinked?: boolean;
}

export const User = ({
    user,
    variations = [],
    displayNameVariations = [],
    avatarVariations = ['extra-small'],
    isTruncated = false,
    isLinked = true,
}: Props) => (
    <span className={getComponentClasses('user', variations)}>
        <span className="user__avatar">
            <Avatar user={user} isLinked={isLinked} variations={avatarVariations} />
        </span>
        <span className="user__display-name">
            <DisplayName
                user={user}
                isLinked={isLinked}
                variations={displayNameVariations}
                isTruncated={isTruncated}
            />
        </span>
    </span>
);

export default User;
